import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { ReduxState } from '../../../AppLoader/types';
import FaqSeo from '../../../builder-io/components/blocks/FAQSeo.builder';
import { FaqBuilderModel } from '../SearchTypes';
import { isSearchFaqFor, loadSearchFaq } from '../actions/SearchActions';
import { selectSearchFaq } from '../selectors/searchSelectors';

/**
 * Renders from the server-provided FAQ on first load, so every question and answer is in the
 * server HTML for crawlers. Fetches from Builder only after client-side navigation to another page.
 */
const SearchFaq = ({
  modelName,
  urlSlug,
  collapseItems = false,
}: {
  modelName: FaqBuilderModel;
  urlSlug: string;
  collapseItems?: boolean;
}) => {
  const dispatch: ThunkDispatch<ReduxState, unknown, AnyAction> = useDispatch();
  const searchFaq = useSelector(selectSearchFaq);

  useEffect(() => {
    dispatch(loadSearchFaq(modelName, urlSlug));
  }, [modelName, urlSlug]);

  const faqItems = isSearchFaqFor(searchFaq, modelName, urlSlug)
    ? searchFaq.faqItems
    : [];

  return (
    <FaqSeo
      faqItems={faqItems}
      collapseItems={collapseItems}
      showButton={false}
    />
  );
};

export default SearchFaq;
